import moment from "moment";

export default {
    format(timeString)
    {
        return moment(timeString).format('DD.MM.YYYY HH:mm')
    }

}